export const configurator = {
    // continue: 'shift+c',
    // finish: 'shift+f',
    // moveTab: 'shift+t'
}